var newLocationPath = location.pathname;
if (newLocationPath !== localStorage.getItem('lastLocationPath') && !location.pathname.toLowerCase().includes('checkout')) {
    localStorage.setItem('lastLocationPath', newLocationPath);
}
